import { TvGuideDictionary } from "core/tv-guide.context";
import context from "core/tv-guide.context";
import { PopupContents } from "core/types";

type VotingButtonProps = {
    popupContents: PopupContents,
    text: string,
    analytics: any
}


const VotingButton = (props: VotingButtonProps) => {
    const { popupContents, analytics, text } = props;

    if (!popupContents.link.votingLink || popupContents.link.hide) {
        return null;
    }

    return (
        <a
            type="button"
            className="button programme-btn m-1"
            target="_blank"
            rel="noreferrer"
            href={`${popupContents.link.votingLink}`}
            {...analytics}
        >
            <span className="icon-star_outline"></span>
            <span className="text">{text}</span>
        </a>
    );
}

export default VotingButton;